import { createFileRoute } from "@tanstack/react-router";
import { MentionsLegalesPage } from "@/views/public/legal/MentionsLegalesPage.tsx";

export const Route = createFileRoute("/_public/mentions-legales")({
  component: MentionsLegalesPage,
});
